// Selector de escenario + insignia permanente "DATOS DE DEMOSTRACIÓN".
// Imposible confundir qué modo se está viendo.
import { useScenario } from "@/context/ScenarioContext";
import { useAuth } from "@/context/AuthContext";
import { FlaskConical, RotateCcw } from "lucide-react";

const OPTS = [
  { key: "real", label: "Datos reales / Laboratorio" },
  { key: "demo_inst", label: "Demo Institucional · 20 camas" },
  { key: "demo_resid", label: "Demo Central Residencial · 30 personas" },
];

export function DemoBadge({ className = "" }) {
  const { isDemo } = useScenario();
  if (!isDemo) return null;
  return (
    <span data-testid="demo-badge"
      className={`items-center gap-1.5 rounded-full bg-[#9B2C2C] px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wider text-white shadow-sm ${className || "inline-flex"}`}>
      <FlaskConical className="h-3.5 w-3.5" /> Datos de demostración
    </span>
  );
}

export default function ScenarioSwitch() {
  const { scenario, setScenario, isDemo, resetDemo } = useScenario();
  const { isExternal, isSupervisor } = useAuth();
  // Gate D: los escenarios demo son una herramienta interna de Galarya.
  // v2.13.3: además, son herramienta COMERCIAL del supervisor. El monitorista opera datos reales:
  // no se le ofrecen escenarios de demostración ni controles de prueba.
  if (isExternal || !isSupervisor) return null;
  return (
    <div data-testid="scenario-switch" className="flex min-w-0 flex-wrap items-center gap-2">
      <select data-testid="scenario-select" value={scenario} onChange={(e) => setScenario(e.target.value)}
        title="Escenario de visualización"
        className={`max-w-[150px] truncate rounded-lg border px-2.5 py-1.5 text-xs font-bold outline-none sm:max-w-none ${
          isDemo ? "border-[#9B2C2C]/50 bg-[#9B2C2C]/10 text-[#9B2C2C] dark:text-[#F2B8B8] dark:bg-[#9B2C2C]/25"
                 : "border-slate-200 bg-white text-slate-600 dark:border-[#263B5D] dark:bg-[#14243A] dark:text-slate-200"}`}>
        {OPTS.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
      </select>
      {isDemo && (
        <button data-testid="demo-reset-button" onClick={resetDemo} aria-label="Reiniciar demostración"
          title="Reconstruye el estado inicial de la demostración (sólo en memoria)"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-[#9B2C2C]/40 px-2.5 py-1.5 text-xs font-semibold text-[#9B2C2C] transition-colors hover:bg-[#9B2C2C]/10 dark:text-[#F2B8B8]">
          <RotateCcw className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Reiniciar demostración</span>
        </button>
      )}
      <DemoBadge className="hidden lg:inline-flex" />
    </div>
  );
}
